import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import authService from "../services/auth";

function SecretarioOuAnalistaRoute({ children }) {
  const [user] = useState(authService.getCurrentUser());
  const [loading, setLoading] = useState(true);
  const [isAutorizado, setIsAutorizado] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const verificar = async () => {
      try {
        setLoading(true);
        setError(null);

        let usuario = authService.getCurrentUser();
        if (!usuario) {
          setLoading(false);
          return;
        }
        if (usuario && usuario.data && (usuario.data.isAnalista || usuario.data.isSecretario)) {
          setIsAutorizado(true);
          setLoading(false);
          return;
        } else {
          setLoading(false);
          return;
        }
      } catch (e) {
        console.error(
          "SecretarioOuAnalistaRoute: Erro ao verificar permissões:",
          e,
        );
        setError("Erro ao verificar suas permissões.");
        setLoading(false);
      }
    };

    verificar();
  }, [navigate]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          Verificando permissões...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <Alert severity="error" sx={{ mb: 3, maxWidth: 600 }}>
          {error}
        </Alert>
        <Button
          variant="contained"
          color="primary"
          onClick={() => window.location.reload()}
          sx={{ mt: 2 }}
        >
          Tentar novamente
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate("/dashboard")}
          sx={{ mt: 2 }}
        >
          Voltar para o Dashboard
        </Button>
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!isAutorizado) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <Alert severity="warning" sx={{ mb: 3, maxWidth: 600 }}>
          <Typography variant="h6" gutterBottom>
            Acesso restrito
          </Typography>
          <Typography variant="body1" gutterBottom>
            Esta área é exclusiva para analistas e secretários. Você não tem
            permissões para acessar esta página.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Usuário: {user.username} (
            {user.data?.isAnalista
              ? "Analista"
              : user.data?.isSecretario
              ? "Secretário"
              : "Usuário Normal"}
            )
          </Typography>
        </Alert>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/dashboard")}
          sx={{ mt: 2 }}
        >
          Voltar para o Dashboard
        </Button>
      </Box>
    );
  }

  return children;
}

export default SecretarioOuAnalistaRoute;
